import clsx from 'clsx'
import { FC } from 'react'
import { BasicStyledComponent, DSTeamMemberShort } from 'shared-definitions/types'
import styles from './AuthorShortLine.module.css'
import AppImage from './AppImage'
import CommentsCount from '../posts/CommentsCount'

interface AuthorShortLineProps {
  author: DSTeamMemberShort
  engagementContainerId: string | null
}

const AuthorShortLine: FC<AuthorShortLineProps & BasicStyledComponent> = ({
  author,
  engagementContainerId,
  className,
}) => (
  <div className={clsx(styles.container, className)}>
    {author.image && (
      <AppImage sizes={[24]} className={styles.image} layout="raw" image={author.image} />
    )}
    {author.name}
    {engagementContainerId && (
      <>
        <span className={styles.sep}>{'•'}</span>
        <CommentsCount containerId={engagementContainerId} />
      </>
    )}
  </div>
)

export default AuthorShortLine
